/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_KindInputs */

const en_fw_notify_kind = /** @type {(inputs: Fw_Notify_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const id_fw_notify_kind = /** @type {(inputs: Fw_Notify_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Fw_Notify_KindInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_kind = /** @type {((inputs?: Fw_Notify_KindInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_KindInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_kind(inputs)
	return en_fw_notify_kind(inputs)
});